import { type QueryResult, useQuery } from "@apollo/client";

import { RETRY_TRANSIENT } from "../../apollo/provider/createTransientRetryLink";
import { lensDetailsScores } from "../api/queries/lensDetailsScores";
import {
    type LensDetailsScoresQuery,
    type LensDetailsScoresQueryVariables,
} from "../api/queries/lensDetailsScores.gql-generated";

export const useLensDetailsScores = (
    unlockableId: string,
    calendarMonth: string,
): QueryResult<LensDetailsScoresQuery, LensDetailsScoresQueryVariables> =>
    useQuery<LensDetailsScoresQuery, LensDetailsScoresQueryVariables>(lensDetailsScores, {
        variables: {
            input: {
                calendarMonth,
                unlockableIds: [unlockableId],
                includeCreatorTotal: false,
                includePriorClosedMonth: true,
            },
        },
        // ESTIMATED windows are recomputed daily; never serve one from cache alone.
        fetchPolicy: "cache-and-network",
        context: RETRY_TRANSIENT,
    });
